import { defineMessages } from 'react-intl';

export default defineMessages({
  offerTitle: {
    id: 'transaction.offer_title',
  },
  offerIndemnityTitle: {
    id: 'transaction.offer_indemnity',
  },
  responsability: {
    id: 'transaction.responsability',
  },
  ReceiptDocumentTitle: {
    id: 'receipt_transaction_document.title',
  },
  ReceiptDocumentSubTitle: {
    id: 'receipt_transaction_document.sub_title',
  },
  ReceiptDocumentParagraph1: {
    id: 'receipt_transaction_document.paragraph_1',
  },
  ReceiptDocumentParagraph2: {
    id: 'receipt_transaction_document.paragraph_2',
  },
  ReceiptDocumentParagraph3: {
    id: 'receipt_transaction_document.paragraph_3',
  },
  ReceiptDocumentParagraph4: {
    id: 'receipt_transaction_document.paragraph_4',
  },
  ReceiptDocumentParagraph5: {
    id: 'receipt_transaction_document.paragraph_5',
  },
  ReceiptDocumentParagraph6: {
    id: 'receipt_transaction_document.paragraph_6',
  },
  ReceiptDocumentParagraph7: {
    id: 'receipt_transaction_document.paragraph_7',
  },
  ReceiptDocumentParagraph8: {
    id: 'receipt_transaction_document.paragraph_8',
  },
  ReceiptDocumentParagraph9: {
    id: 'receipt_transaction_document.paragraph_9',
  },
  ReceiptDocumentFooter1: {
    id: 'receipt_transaction_document.footer_1',
  },
  ReceiptDocumentFooter2: {
    id: 'receipt_transaction_document.footer_2',
  },
  downloadDocumentReciept: {
    id: 'download_receipt_transaction_document.title',
  },
  paymentMethod: { id: 'legal-proceedings.risk.payment_method' },
  recipient: {
    id: 'legal-proceedings.risk.information.recipient',
  },
  linkToBeneficiary: {
    id: 'legal-proceedings.risk.information.linkToBeneficiary',
  },
  town: {
    id: 'legal-proceedings.risk.information.town',
  },
  country: {
    id: 'legal-proceedings.risk.information.country',
  },
  regulationAccordionTitle: {
    id: 'regulation_transaction.accordion_title',
  },
  regulationPhase: {
    id: 'legal-proceedings.risk.information.regulation_phase',
  },
  paymentChannel: { id: 'legal-proceedings.risk.payment_channel' },
  beneficiaryReference: {
    id: 'legal-proceedings.risk.information.beneficiaryReference',
  },
  bnejCity: {
    id: 'legal-proceedings.risk.risk_information.bnej_city',
  },
  successToastCreateRegulation: {
    id: 'legal-proceedings.risk_corporeal.creation.toast_success',
  },
  validatedButtonTitle: {
    id: 'navigation_button.save',
  },
  rate: {
    id: 'offer.rate.title',
  },
  prejudiceMaterial: {
    id: 'offer.prejudice_material.title',
  },
  prejudiceMoral: {
    id: 'offer.prejudice_morale.title',
  },
  beneficiaryTitle: {
    id: 'legal-proceedings.risk.beneficiaries',
  },
  addRegulationTilte: {
    id: 'regulation.transaction.button_title',
  },
  validationTitle: {
    id: 'global.validation_title',
  },
  addDocumentTitle: {
    id: 'expert_expertise.doc_stamped.title',
  },
  dateReception: {
    id: 'transaction.date_reception',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  uploadSuccess: {
    id: 'transaction.document_quotation.success.title',
  },
  receiptMajorVictimTitle: {
    id: 'receipt_victim_major_transaction.title',
  },
  receiptMajorVictimSubTitle: {
    id: 'receipt_victim_major_transaction.sub_title',
  },
  receiptMajorVictimFirstParaph: {
    id: 'receipt_victim_major_transaction.first_paragraph',
  },
  receiptMajorVictimSecondParagraph: {
    id: 'receipt_victim_major_transaction.second_paragraph',
  },
  victimBox: {
    id: 'receipt_victim_major_transaction.victim_box',
  },
  revenuBox: {
    id: 'receipt_victim_major_transaction.revenu_box',
  },
  birthDateBox: {
    id: 'receipt_victim_major_transaction.birth_date_box',
  },
  cinBox: {
    id: 'receipt_victim_major_transaction.cin_box',
  },
  refBox: {
    id: 'receipt_victim_major_transaction.reference_box',
  },
  prejudicBox: {
    id: 'receipt_victim_major_transaction.prejudic_box',
  },
  natureBox: {
    id: 'receipt_victim_major_transaction.nature_box',
  },
  rateBox: {
    id: 'receipt_victim_major_transaction.rate_box',
  },
  amountBox: {
    id: 'receipt_victim_major_transaction.amount_box',
  },
  rateIpp: {
    id: 'receipt_victim_major_transaction.rate_ipp',
  },
  painDamage: {
    id: 'receipt_victim_major_transaction.pain_damage',
  },
  aestheticDamageWithoutConseq: {
    id: 'receipt_victim_major_transaction.aesthetic_damage_without_conseq',
  },
  aestheticDamageWithConseq: {
    id: 'receipt_victim_major_transaction.aesthetic_damage_with_conseq',
  },
  useThirdParty: {
    id: 'receipt_victim_major_transaction.use_third_party',
  },
  careerDamage: {
    id: 'receipt_victim_major_transaction.career_damage',
  },
  educationDamage: {
    id: 'receipt_victim_major_transaction.education_damage',
  },
  materialDamage: {
    id: 'receipt_victim_major_transaction.material_damage',
  },
  medicalFees: {
    id: 'receipt_victim_major_transaction.medical_fees',
  },
  thirdParagraph: {
    id: 'receipt_victim_major_transaction.third_paragraph',
  },
  firstDotText: {
    id: 'receipt_victim_major_transaction.first_dot_text',
  },
  secondDotText: {
    id: 'receipt_victim_major_transaction.second_dot_text',
  },
  thirdDotText: {
    id: 'receipt_victim_major_transaction.third_dot_text',
  },
  forthDotText: {
    id: 'receipt_victim_major_transaction.forth_dot_text',
  },
  fifthDotText: {
    id: 'receipt_victim_major_transaction.fifth_dot_text',
  },
  sixthDotText: {
    id: 'receipt_victim_major_transaction.sixth_dot_text',
  },
  ReceiptDocumentFooter3: {
    id: 'receipt_transaction_document.footer_3',
  },
  ReceiptDocumentFooter4: {
    id: 'receipt_transaction_document.footer_4',
  },
  ReceiptDocumentFooter5: {
    id: 'receipt_transaction_document.footer_5',
  },
  ReceiptDocumentFooter6: {
    id: 'receipt_transaction_document.footer_6',
  },
  ReceiptDocumentMinorSecondParagraph: {
    id: 'receipt_victim_major_transaction.second_paragraph_minor',
  },
  totalAmount: {
    id: 'receipt_victim_major_transaction.total_amount',
  },
  warningTitleTutor: {
    id: 'transaction.tutor.warning_title',
  },
  tutor: {
    id: 'transaction.tutor.title',
  },
  victimCin: {
    id: 'preopening_page.victim.cin',
  },
  victimFirstName: {
    id: 'preopening_page.victim.first_name',
  },
  victimLastName: {
    id: 'preopening_page.victim.last_name',
  },
  confirm: {
    id: 'fee_note.confirm_btn',
  },
  cancel: {
    id: 'cancel_btn',
  },
  cinInvalid: {
    id: 'preopening_page.victim.invalid_cin_victim',
  },
  addTutorButtonTitle: {
    id: 'transaction.add_tutor.title',
  },
  successCallBackMessage: {
    id: 'transaction.success_call_back.message.tutor',
  },
});
